export enum MissionTrackingEventName {
    missionStarted = 'missionStarted',
    missionFailed = 'missionFailed',
    missionCompleted = 'missionCompleted',
}

export enum TrackingEventName {
    newPlayer = 'newPlayer',
    gameStarted = 'gameStarted',
    gameLoaded = 'gameLoaded',
}

export enum AdTrackingEventName {
    adRequest = 'adRequest',
    adShow = 'adShow',
}

export enum ResourceTrackingEventName {
    resource = 'resource',
}

export enum UserEventName {
    userUnification = 'userUnification',
}

export enum FTUXTrackingEventName {
    ftux = 'ftux',
}

export enum TransactionTrackingEventName {
    transaction = 'transaction',
}

export enum SocialActionEventName {
    socialAction = 'socialAction',
}

export enum QuestEventName {
    questStart = 'questStart',
}

export enum FarmTrackingEventName {
    myFarmUpdate = 'myFarmUpdate',
}

export type allTrackingEvents =
    | MissionTrackingEventName
    | AdTrackingEventName
    | TrackingEventName
    | ResourceTrackingEventName
    | TransactionTrackingEventName
    | FTUXTrackingEventName
    | SocialActionEventName
    | QuestEventName
    | UserEventName
    | FarmTrackingEventName
